/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Icon Directive
 *
 * @example
 * ```html
 *  <i class="icon icon-home"></i>
 *  <i class="icon" data-icon="home"></i>
 *  <i class="icon" data-name="home"></i>
 * ```
 */
export const iconDirective = {
  /**
   * Selectors for the directive
   */
  selectors: ['.icon', '[class*="icomoon"]'],

  /**
   * @type {string[]}
   */
  icons: null,

  /**
   * Initialize directive on element
   *
   * @param {HTMLElement} element The DOM element
   * @param {object} options Resolved options from all sources
   */
  init(element) {
    if (!this.icons) {
      this.icons = [...document.querySelectorAll('.svg-sprite-container symbol[id]')].map(symbol => symbol.getAttribute('id'));
    }

    if (element.childElementCount === 0) {
      this.injectIcon(element);
    }
  },

  /**
   * Clean up when element is removed from DOM
   *
   * @param {HTMLElement} element The DOM element being removed
   */
  destroy(element) {},

  /**
   * Inject icon into element
   *
   * @protected
   *
   * @param {HTMLElement} element
   */
  injectIcon(element) {
    const {icon, name} = element.dataset;
    const iconName = icon || name || element.className.match(/(?:^|\s)(?:icon|icomoon)-(.*?)(?:\s|$)/)?.[1];

    if (iconName && this.icons.includes(iconName)) {
      element.innerHTML = `<svg><use xlink:href="#${iconName}"></use></svg>`;
    } else if (!iconName) {
      console.warn(`Cannot resolve icon name for element: ${element.tagName.toLowerCase()}.${element.className}`);
    } else {
      console.warn(`Icon name '${iconName}' not found in SVG sprite for element: ${element.tagName.toLowerCase()}.${element.className}`);
    }
  }
};
